<div class="header">
  <div>
    <h2>{{ viewHistory ? "Policy History" : "Policies" }}</h2>
    <p>
      {{
        viewHistory
          ? "View a complete record of all policy changes, updates, and previous versions in one place to quickly review
      historical updates and maintain consistency."
          : "Manage, view and update all company policies to ensure your team follows guidelines and stays aligned with
      organizational rules."
      }}
    </p>
  </div>
  <button *ngIf="!viewHistory" class="add-btn" (click)="toggleModal()">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Policy
  </button>
  <button *ngIf="viewHistory" class="add-btn" (click)="viewHistory = false">
    <span class="text-light">&#8678;</span>
    Back to Policies
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table *ngIf="!viewHistory">
      <thead>
        <tr>
          <th>Title</th>
          <th>Added Date</th>
          <th class="text-right pr-5">Action</th>
        </tr>
      </thead>

      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of policies; track item.id) {
          <tr>
            <td>{{ item.policy_title }}</td>
            <td>{{ item.created_at | date: "dd-MM-yyyy" }}</td>
            <td class="text-right icon-btns">
              <button class="btn-icon" (click)="openHistory()">
                <img src="assets/images/prime_history.svg" alt="History" />
              </button>
              <button class="btn-icon" (click)="openEditModal(item)">
                <img src="assets/images/editIcon.svg" alt="Edit" />
              </button>
              <button class="btn-icon" (click)="openDeleteModal(item.id)">
                <img src="assets/images/trashIcon.svg" alt="Delete" />
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="table-wrapper">
    <div *ngIf="viewHistory" class="history-timeline">
      <div class="timeline-container">
        <div class="timeline-item">
          <div class="timeline-date">22-03-2025 <span class="dot"></span></div>
          <div class="timeline-content">
            <div class="history-card">
              <div class="card-header" (click)="toggleCollapse(0)">
                <span class="chevron">
                  <img
                    [src]="
                      expandedIndices.includes(0)
                        ? 'assets/images/Unfold_Icon.svg'
                        : 'assets/images/Fold_Icon.svg'
                    "
                    alt="icon"
                    class="mr-2"
                  />
                </span>
                <div class="user-info">
                  <img
                    src="https://i.pravatar.cc/40?img=1"
                    alt="user"
                    class="avatar"
                  />
                  <span class="user-name">Clara Waters</span>
                  <span class="badge purple">Changed Title</span>
                </div>
              </div>
              <div class="card-body" *ngIf="expandedIndices.includes(0)">
                <div class="diff-row">
                  <div class="diff-box">
                    During your term of employment, you will be reporting
                    directly to the Manger.
                  </div>
                  <img src="/assets/images/arrow-right.svg" alt="arrow" />
                  <div class="diff-box changed">
                    During your employment period, you will report directly to
                    the Manager.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-date">22-03-2024 <span class="dot"></span></div>
          <div class="timeline-content">
            <div class="history-card">
              <div class="card-header" (click)="toggleCollapse(1)">
                <span
                  class="chevron"
                  [class.open]="expandedIndices.includes(1)"
                >
                  <img
                    [src]="
                      expandedIndices.includes(1)
                        ? 'assets/images/Unfold_Icon.svg'
                        : 'assets/images/Fold_Icon.svg'
                    "
                    alt="icon"
                    class="mr-2"
                  />
                </span>
                <div class="user-info">
                  <img
                    src="https://i.pravatar.cc/40?img=5"
                    alt="user"
                    class="avatar"
                  />
                  <span class="user-name">Nellie Feest</span>
                  <span class="badge blue">Changed Description</span>
                </div>
              </div>
              <div class="card-body" *ngIf="expandedIndices.includes(1)">
                <div class="diff-row">
                  <div class="diff-box">
                    During your term of employment, you will be reporting
                    directly to the Manger.
                  </div>
                  <div class="arrow">
                    <img src="assets/images/arrow-right.svg" alt="arrow" />
                  </div>
                  <div class="diff-box changed">
                    During your employment period, you will report directly to
                    the Manager.
                  </div>
                </div>
                <div class="diff-row">
                  <div class="diff-box">
                    During your employment, you are not supposed to disclose any
                    confidential information...
                  </div>
                  <div class="arrow">
                    <img src="assets/images/arrow-right.svg" alt="arrow" />
                  </div>
                  <div class="diff-box changed">
                    You are required to maintain strict confidentiality...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-date">22-03-2023 <span class="dot"></span></div>
          <div class="timeline-content">
            <div class="history-card">
              <div class="card-header" (click)="toggleCollapse(2)">
                <span
                  class="chevron"
                  [class.open]="expandedIndices.includes(2)"
                >
                  <img
                    [src]="
                      expandedIndices.includes(2)
                        ? 'assets/images/Unfold_Icon.svg'
                        : 'assets/images/Fold_Icon.svg'
                    "
                    alt="icon"
                    class="mr-2"
                  />
                </span>
                <div class="user-info">
                  <img
                    src="https://i.pravatar.cc/40?img=3"
                    alt="user"
                    class="avatar"
                  />
                  <span class="user-name">Clay Kohler</span>
                  <span class="badge light-blue">Created</span>
                </div>
              </div>
              <div class="card-body" *ngIf="expandedIndices.includes(2)">
                <div class="full-view">
                  <label>Title</label>
                  <div class="static-input">Basic Policies 2025 to 2026</div>
                  <label>Description</label>
                  <div class="static-textarea">
                    As the contractual employee of the company...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-popup
  *ngIf="showModal"
  [title]="isEditMode ? 'Edit Policy' : 'Add New Policy'"
  [subtitle]="
    isEditMode
      ? 'Update policy to guide your team and maintain clear company rules.'
      : 'Create a new policy to guide your team and maintain clear company rules.'
  "
  [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  "
  (close)="toggleModal()"
>
  <form [formGroup]="policyForm" (ngSubmit)="onSave()">
    <div class="input-group">
      <label>Title*</label>
      <input
        type="text"
        formControlName="policy_title"
        placeholder="Write here"
      />
    </div>
    <div class="input-group">
      <label>Description*</label>
      <div class="editor-container">
        <ckeditor
          [editor]="Editor"
          formControlName="policy_description"
        ></ckeditor>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal()">
        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="policyForm.invalid">
        <img src="assets/images/savePopup.svg" alt="" /> Save
      </button>
    </div>
  </form>
</app-add-popup>
<!-- Delete Confirmation Modal -->
<app-add-popup
  *ngIf="showDeleteModal"
  title="Delete Policy"
  subtitle="Are you sure you want to delete this policy? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg"
  (close)="closeDeleteModal()"
>
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="closeDeleteModal()">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span> Delete
    </button>
  </div>
</app-add-popup>
